import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; // deprecated
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react'; // deprecated
import { toast } from 'react-toastify';
import i18nContext from 'components/i18n-context';
import { PopConfirmationScheme } from 'components/PopUpScheme/PopConfirmationScheme';
import { refreshExchangeRatesRequest } from 'services/requestAgent';
import Button from 'uikit/Button/Button';
import { PopUp } from 'uikit/PopUp/PopUp';
import { Toggle } from 'uikit/Toggle/Toggle'; // deprecated
import './MaintenanceTab.scss';

const MaintenanceTab = ({ settingsStore }) => {
  const i18n = useContext(i18nContext);
  const location = useLocation(); // deprecated
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmPopUpOpen, setIsConfirmPopUpOpen] = useState(false);

  // deprecated
  useEffect(() => {
    if (!settingsStore.isInitialized) {
      settingsStore.getApplicationProperties();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingsStore.isInitialized]);

  // deprecated
  useEffect(() => {
    if (settingsStore.isInitialized) {
      settingsStore.resetSettingsStore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleRefreshClick = () => {
    setIsConfirmPopUpOpen(true);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    setIsConfirmPopUpOpen(false);

    const toastPromise = toast.promise(refreshExchangeRatesRequest(), {
      pending: i18n.getMessage('maintenance.refreshExchangeRates.toast.pending'),
      success: i18n.getMessage('maintenance.refreshExchangeRates.toast.success')
    });

    try {
      await toastPromise;
    } catch (err) {
      // Error handling is done by requestAgent
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setIsConfirmPopUpOpen(false);
  };

  return (
    <div className={'maintenance-wrapper'}>
      <div className={'maintenance-section'}>
        <h3 className={'maintenance-section-title'}>{i18n.getMessage('maintenance.exchangeRates.title')}</h3>
        <p className={'maintenance-section-description'}>{i18n.getMessage('maintenance.exchangeRates.description')}</p>
        <Button
          className={'maintenance-refresh-button'}
          type={'primary'}
          size={'medium'}
          onClick={handleRefreshClick}
          isDisabled={isLoading}
        >
          {isLoading
            ? i18n.getMessage('maintenance.refreshExchangeRates.button.loading')
            : i18n.getMessage('maintenance.refreshExchangeRates.button')}
        </Button>
      </div>

      {/* deprecated */}
      <div className={'maintenance-section'}>
        <h3 className={'maintenance-section-title'}>
          {i18n.getMessage('maintenance.converaMerchantAutoPayments.title')}
        </h3>
        <p className={'maintenance-section-description'}>
          {i18n.getMessage('maintenance.converaMerchantAutoPayments.description')}
        </p>
        <Toggle
          className={'maintenance-toggle'}
          isEnabled={settingsStore.isConveraMerchantAutoPaymentsEnabled}
          onChange={settingsStore.updateConveraMerchantAutoPayments}
          disabled={!settingsStore.isInitialized || settingsStore.isLoading}
          label={i18n.getMessage('maintenance.converaMerchantAutoPayments.label')}
        />
      </div>

      <PopUp alignOnCenter show={isConfirmPopUpOpen} onClose={handleClose}>
        <PopConfirmationScheme
          isLoading={isLoading}
          title={i18n.getMessage('maintenance.refreshExchangeRates.confirm.title')}
          description={i18n.getMessage('maintenance.refreshExchangeRates.confirm.description')}
          onConfirmButtonTitle={i18n.getMessage('maintenance.refreshExchangeRates.confirm.yes')}
          onCloseButtonTitle={i18n.getMessage('maintenance.refreshExchangeRates.confirm.no')}
          onConfirm={handleConfirm}
          onClose={handleClose}
        />
      </PopUp>
    </div>
  );
};

// deprecated
MaintenanceTab.propTypes = {
  settingsStore: MobXPropTypes.observableObject
};

// deprecated (inject/observer needed only for the Convera Merchant toggle)
export default inject((stores) => ({
  settingsStore: stores.settingsStore
}))(observer(MaintenanceTab));
